// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Header_Logo__1YvxC","Menu":"Header_Menu__3ntcd","LanguageSwitcher":"Header_LanguageSwitcher__2U2r0"};